import { convertDataLayerPayload } from '../transformers';
import { pushToDataLayer } from '../';

const pushDetailImpression = (payload) => {
  if (!payload) {
    return;
  }

  pushToDataLayer({
    event: 'Ecommerce Detail Impression',
    ...convertDataLayerPayload(payload),
  });
};

export default pushDetailImpression;
